import type { User } from '../types';

export function getPersonalHouseholdId(userId: string): string {
    return `hh-${userId}`;
}

export function resolveActiveHouseholdId(
    user: Pick<User, 'uid' | 'activeHouseholdId' | 'households'>,
    availableHouseholdIds?: readonly string[],
): string {
    const personalId = getPersonalHouseholdId(user.uid);
    const membershipIds = user.households || [];
    const candidateIds = availableHouseholdIds && availableHouseholdIds.length > 0
        ? availableHouseholdIds
        : membershipIds.length > 0
            ? membershipIds
            : [personalId];

    const isValidActive = (id?: string | null): id is string =>
        !!id && candidateIds.includes(id);

    if (isValidActive(user.activeHouseholdId)) {
        return user.activeHouseholdId;
    }
    if (candidateIds.includes(personalId)) {
        return personalId;
    }
    return candidateIds[0] || personalId;
}
